import { clamp } from '~/src/common/utils/number';

interface Options {
  maxScore: number;
  showHalves: boolean;
}
export const getIconList = (score: number, options: Options) => {
  const { maxScore, showHalves } = options;
  const clampedScore = clamp(score, 0, maxScore);

  return Array.from({ length: maxScore }, (_, i) => {
    const remainder = clampedScore - i;
    if (remainder >= 1) return '🌕';
    if (!showHalves) {
      if (remainder >= 0.5) return '🌕';
    } else {
      if (remainder >= 0.75) return '🌕';
      if (remainder >= 0.25) return '🌗';
    }
    return '🌑';
  });
};
